var map = {
	"./background.png": "9855",
	"./bjcsxy-logo.png": "9921",
	"./camera-control-close.svg": "c41a",
	"./camera-control-open.svg": "f49e",
	"./camera-on.png": "bf17",
	"./camera.png": "5e4f",
	"./chat.png": "ffb1",
	"./close.png": "d991",
	"./defaultHead.png": "60d0",
	"./error.png": "fa93",
	"./exit-fullscreen.svg": "e478",
	"./full-on.png": "96fd",
	"./full.png": "8fa7",
	"./log2.png": "f01f",
	"./maximize.svg": "6723",
	"./mic-on.png": "6d795",
	"./mic.png": "89b2",
	"./micList-off.png": "abf8",
	"./micList.png": "649a",
	"./microphone-control-close.svg": "4478",
	"./microphone-control-open.svg": "6e6f",
	"./muteall-2x.png": "b3e7",
	"./muteall-on-2x.png": "36cd",
	"./muteall-on.png": "275a",
	"./muteall.png": "48d5",
	"./na.png": "6a45",
	"./nodata.png": "9485",
	"./nv.png": "8009",
	"./off-2x.png": "bd4d",
	"./off.png": "a303",
	"./question-bank-to-top.png": "0ef5",
	"./screen-2x.png": "07a4",
	"./screen-control-close.svg": "e3a5",
	"./screen-control-open.svg": "4b84",
	"./screen-on-2x.png": "95f7",
	"./screen-on.png": "421b",
	"./screen.png": "4a8c",
	"./setting-2x.png": "99e7",
	"./setting.png": "abf7",
	"./sologan.png": "feab",
	"./success.png": "46e6",
	"./up.png": "9b31",
	"./video-error.png": "352f",
	"./volume-0.svg": "c24a",
	"./volume-bar.svg": "58cb",
	"./volume-have.svg": "503f",
	"./volume-mute.svg": "0ab4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";